import React, { Component } from 'react';
import { observer, inject, mobx } from "mobx-react";
import { PDFDownloadLink } from "@react-pdf/renderer";
/* Component */
import { BackgroundIconCard } from '@sogei/react-web-components-catalog'
import TiTroviIn from '../widgets/titroviin.jsx'
import Wizard from '../widgets/addWizard.jsx'

/* css */
import '../../assets/css/esclusione/esclusione.css'

@inject("rootStore")
@observer
class Riepilogo extends Component {
    constructor (props) {
        super(props);
        this.state = {}
        this.infoStore = this.props.rootStore.infoStore
    }

    handleStampa () {
        let dC = this.infoStore.datiConferma;
        return (<button type="submit" className="btn btn-outline-primary" onClick={ () => this.infoStore.handleStampaRiepilogo(
            this.infoStore.denominazione, this.infoStore.sede, this.infoStore.cap, this.infoStore.citta, this.infoStore.statoAttivita, this.infoStore.datiConferma.azcng8A_PROT_TEL,
            this.infoStore.datiConferma.azcng8A_DTPROT, this.infoStore.Information, this.infoStore.CF, this.infoStore.stato, this.infoStore.vat, this.infoStore.issuedCountry) }> Print   </button>
        )
    }

    render () {

        const { datiConferma } = this.infoStore;
        const to = [
            {
                to: `${ process.env.CONTEXT_PATH }/home`,
                label: 'Home'
            }
        ]
        return (
            <>

                <section className="section py-2 py-md-3">
                    <div className="container-fluid py-3 py-md-4 backColor">
                    <TiTroviIn children={to} title={'Summary'} index={2} ></TiTroviIn>

                        <div className="row">
                            <div className="col font-weight-bold mt-3 mb-3">
                                <span className="d-flex">
                                    <h3> <strong className="fa-title far fa-file-alt mr-3"></strong>Summary</h3>
                                </span>
                            </div>
                        </div>
                        <Wizard index={3}/>
                 {/*        <div className="row">
                            <div className="col-6">
                                <hr className="borderTitle"></hr>
                            </div>
                        </div> */}
                    {/* JJ dac7
                        <div className="row ml-1 mb-4">
                            <span className="font-weight-bold title"> Registration result for iOSS</span>
                        </div>
                   */}     
                        <div className="row">
                            <div className="col-2" />
                            <div className="col">
                                <BackgroundIconCard body={ <>
                                    <div className="alert alert-success d-flex col-9" role="alert">
                                        <p className="alert-content" >Request successfully acquired</p>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col">
                                            <span className="font-weight-bold">Reference number: </span><span >{ datiConferma.azcng8A_PROT_TEL } </span>
                                            <span className="font-weight-bold">  of: </span>
                                            <span>
                                                { datiConferma.azcng8A_DTPROT.azcng8A_DTPROT_MM + '/' + datiConferma.azcng8A_DTPROT.azcng8A_DTPROT_GG + '/' + datiConferma.azcng8A_DTPROT.azcng8A_DTPROT_AAAA }
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col">
                                            <span className="font-weight-bold">Company name: </span>
                                            <span >{ this.infoStore.denominazione} </span>
                                        </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col">
                                            <span className="font-weight-bold">National tax reference: </span>
                                            <span >{ this.infoStore.CF+" ("+ this.infoStore.stato+")"} </span>
                                        </div>
                                    </div>


                                </> }>
                                </BackgroundIconCard>
                            </div>
                            <div className="col-2" />
                        </div>
                        <div className="row">
                            <div className="col-2" />
                            <div className="col-3 d-flex">
                                { this.handleStampa() }
                            </div>
                        </div>

                    </div>
                </section>
            </>
        )
    };
}

export default Riepilogo;


